const GalagaBoard = () => import(/* webpackChunkName: "galaga-board" */ '../pages/galaga-board/index');
const RankingSettings = () => import(/* webpackChunkName: "ranking-settings" */ '../pages/ranking-settings/index');

const routes = [
  { path: '/', component: RankingSettings },
  { path: '/leaderboard', component: GalagaBoard }
];

export default routes;